import { render, staticRenderFns } from "./GeneralImageSelectorWidget.vue?vue&type=template&id=0f5a55e2&"
import script from "./GeneralImageSelectorWidget.vue?vue&type=script&lang=js&"
export * from "./GeneralImageSelectorWidget.vue?vue&type=script&lang=js&"
import style0 from "./GeneralImageSelectorWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCarousel,VCarouselItem,VCol,VImg,VRow})
